// Auth HTTP wrappers — login, logout, hydrate (/me).

import { getData, postData } from '../../lib/api-client';
import type { AdminRole, AdminUser } from './auth.store';

export interface LoginResponse {
  accessToken: string;
  user: AdminUser;
}

export interface LoginInput {
  username: string;
  password: string;
}

export async function login(input: LoginInput): Promise<LoginResponse> {
  return postData<LoginResponse>('/admin/auth/login', input);
}

export async function logout(): Promise<void> {
  await postData('/admin/auth/logout');
}

export async function fetchMe(): Promise<{ id: string; username: string; role: AdminRole }> {
  return getData('/admin/auth/me');
}
